// CreateWebsitePage.js
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export const WebsiteCreate = () => {
  const navigator = useNavigate();
  const [websiteData, setWebsiteData] = useState({
    page: "",
    key: "",
    value: "",
  });
  const navigate = useNavigate();
  useEffect(() => {
    async function getInfo() {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/verify`,
          {
            withCredentials: true,
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        );
        if (data.message === "Please login first") {
          navigate("/adminLogin");
        }
      } catch (error) {
        console.log(error);
      }
    }
    getInfo();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setWebsiteData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      // Send a POST request to the backend to create a new website
      const response = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/blogs/hero`, // Assuming the endpoint is correct
        {
          page: websiteData.page,
          key: websiteData.key,
          value: websiteData.value,
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        }
      );

      console.log("New website created:", response.data);
      navigator("/website"); // Redirect to the websites page or any other page
    } catch (error) {
      console.error("Error creating new website:", error);
    }
  };

  return (
    <div>
      <Typography variant="h4">Create New Website</Typography>
      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          margin="normal"
          label="Page"
          name="page"
          value={websiteData.page}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Key"
          name="key"
          value={websiteData.key}
          onChange={handleChange}
        />
        <TextField
          fullWidth
          margin="normal"
          label="Value"
          name="value"
          multiline
          rows={4}
          value={websiteData.value}
          onChange={handleChange}
        />
        {/* Add more form fields based on your website schema */}
        <Button type="submit" variant="contained" color="primary">
          Create Data
        </Button>
      </form>
    </div>
  );
};
